import * as React from 'react';

import { useMemo, useState } from 'react';
import type { AssetResponse } from '@research-api/utils/api/assets';
import PricePageChart from '@/components/pages/price/components/PricePageChart';
import PriceInfoBlock from '@/components/pages/price/components/Header/PriceInfoBlock';
import PriceChartDescription from '@/components/pages/price/components/Content/About/PriceChartDescription';

interface PriceChartWithInfoProps {
    asset: AssetResponse;
}
const PriceChartWithInfo = (props: PriceChartWithInfoProps): JSX.Element => {
    const { asset } = props;

    const [price, setPrice] = useState(asset?.price?.usd || 0);
    const [isBtc, setIsBtc] = useState(false);

    const PricePageChartComp = useMemo(
        () => <PricePageChart asset={asset} setPrice={setPrice} setIsBtc={setIsBtc} />,
        [asset]
    );
    const currentPrice = asset?.price?.usd || 0;

    return (
        <section className="p-8" onMouseLeave={() => setPrice(currentPrice)}>
            <PriceInfoBlock price={price} currentPrice={currentPrice} isBtc={isBtc} ohlcv24h={asset.ohlcv24h} />
            <div className="mt-8">{PricePageChartComp}</div>
            <PriceChartDescription asset={asset} price={currentPrice} />
        </section>
    );
};

export default PriceChartWithInfo;
